import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Chart from 'bizcharts/lib/components/Chart';
import Axis from 'bizcharts/lib/components/Axis';
import Coord from 'bizcharts/lib/components/Coord';
import Legend from 'bizcharts/lib/components/Legend';
import Geom from 'bizcharts/lib/components/Geom';
import Tooltip from 'bizcharts/lib/components/Tooltip';

import { GRAPH_TYPE } from '../../../../../data/config/constants';

class Graph extends Component {
    render() {
        const { type, data, scale, coord_props, x_axis, x_axis_props, y_axis, y_axis_props, legend, legend_position, padding, height, width, animate, forceFit, size, tooltip_crosshairs, shape, color_key, tooltip_props } = this.props;
        let chart_props = { data, scale, animate, forceFit };
        let geom_props = {};

        if (height) {
            chart_props = { ...chart_props, height }
        }
        if (width) {
            chart_props = { ...chart_props, width }
        }
        if (padding) {
            chart_props = { ...chart_props, padding }
        }
        if (color_key) {
            geom_props = { ...geom_props, color: color_key }
        }
        if (shape) {
            geom_props = { ...geom_props, shape }
        }

        if (forceFit) {
            let canvas = document.getElementById("canvas_1");
            if (canvas) {
                canvas.style.width = "100%";
            }
        }
        const position = `${x_axis}*${y_axis}`;

        return (
            <Chart {...chart_props}>
                {
                    legend &&
                    <Legend position={legend_position} />
                }
                <Coord {...coord_props} />
                <Axis name={x_axis} {...x_axis_props} />
                <Axis name={y_axis} {...y_axis_props} />
                <Tooltip crosshairs={tooltip_crosshairs} 
                {...tooltip_props}
                />
                {
                    (type === GRAPH_TYPE.LINE || type === GRAPH_TYPE.AREA) &&
                    <Geom type={GRAPH_TYPE.LINE} position={position} {...geom_props} size={size} />
                }
                {
                    (type === GRAPH_TYPE.AREA || type === GRAPH_TYPE.INTERVAL || GRAPH_TYPE.INTERVAL_STACK) &&
                    <Geom type={type} position={position} {...geom_props} />
                }
            </Chart>
        );
    }
}

Graph.propTypes = {
    type: PropTypes.oneOf(['line', 'area', 'interval', 'intervalStack']).isRequired,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    scale: PropTypes.object,
    coord_props: PropTypes.object,
    x_axis: PropTypes.string.isRequired,
    y_axis: PropTypes.string.isRequired,
    x_axis_props: PropTypes.object,
    y_axis_props: PropTypes.object,
    padding: PropTypes.array,
    height: PropTypes.number,
    width: PropTypes.number,
    size: PropTypes.number,
    legend: PropTypes.bool,
    legend_position: PropTypes.string,
    animate: PropTypes.bool,
    forceFit: PropTypes.bool,
    tooltip_crosshairs: PropTypes.object,
    shape: PropTypes.string,
    color_key: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    tooltip_props: PropTypes.object
};

Graph.defaultProps = {
    legend: false,
    legend_position: "top",
    animate: true,
    forceFit: true,
    tooltip_crosshairs: { type: 'line' },
    size: 2
};

export default Graph;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/charts/graph/index.js